<script setup lang="ts">
import {computed, toRef} from 'vue';
import type {CompanyPulseData} from '@/types/DataTypes';
import PulseTimeAllocationDisplay from './PulseTimeAllocationDisplay.vue';
import {usePulseStats} from '@/composables/usePulseStats';

interface Props {
  pulses: CompanyPulseData[];
}

const props = defineProps<Props>();

// Convert props to reactive reference for the composable
const pulsesRef = toRef(props, 'pulses');

// Use the centralized pulse statistics calculation
const {stats} = usePulseStats(pulsesRef);

// Extract the company allocation from stats
const companyAllocation = computed(() => stats.value.companyAllocation);
</script>

<template>
  <div class="w-full">
    <!-- Company Allocation Bar -->
    <div v-if="Object.keys(companyAllocation).length > 0">
      <PulseTimeAllocationDisplay
        :time-allocation="companyAllocation"
        :show-unallocated="true"
        :show-legend="true"
      />
    </div>

    <!-- No data -->
    <div v-else class="text-xs text-gray-400">No allocation data</div>
  </div>
</template>

